import React from "react";
import _ from "lodash";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import PropTypes from "prop-types";
import FolderMapper from "Components/folderMapper/FolderMapper";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import s from "./vaultImportModal.scss";
import QboxmailApi from "../../qboxmailApi.js";

class VaultImportModal extends React.Component {
  constructor(props) {
    super(props);
    this.startImport = this.startImport.bind(this);
    this.resetAndClose = this.resetAndClose.bind(this);
    this.state = {
      importStarted: false,
      isSubmitting: false,
    };
  }

  startImport() {
    this.setState({ isSubmitting: true });
    const data = _.omitBy(this.folderMapper.getValues(), (val) => val === false || val === "Ignore");

    if (Object.keys(data).length === 0) {
      this.setState({
        isSubmitting: false,
        folderMapperError: "No folders selected",
      });
      return false;
    }

    let client = new QboxmailApi({ useCookie: true });

    client.createArchiveImport(this.props.emailCode, data).then(() => {
      this.setState({
        importStarted: true,
        isSubmitting: false,
        folderMapperError: false,
      });
      this.props.changeArchiveImportStatus(this.props.emailCode, "running");
    });
  }

  resetAndClose() {
    this.setState({ folderMapperError: false });
    this.props.handleClose();
  }

  render() {
    const { opened, areFoldersLoading, folders, emailRetention } = this.props;

    if (this.state.importStarted) {
      return (
        <Modal opened={opened} title={t("modal.import.started.archive.title")} closeModal={this.resetAndClose}>
          <div className={s.content}>
            <TranslatedString>modal.import.started.archive.text</TranslatedString>
          </div>

          <div className={s.footer}>
            <Button type="button" color="outline" onClick={this.resetAndClose}>
              button.close
            </Button>
          </div>
        </Modal>
      );
    }

    return (
      <Modal opened={opened} title={t("modal.import.archive.title")} closeModal={this.resetAndClose}>
        <div className={s.content}>
          <TranslatedString
            subs={{
              retentionAccount: emailRetention,
              duration: emailRetention === 1 ? t("detailInfo.data.year") : t("detailInfo.data.years"),
            }}
          >
            modal.import.archive.text
          </TranslatedString>

          <FolderMapper
            className={s.folderMapper}
            folderNames={Object.keys(folders)}
            folderCounters={folders}
            itemsLabel={t("folderMapper.label.folders")}
            allItems={t("folderMapper.label.all.folders")}
            destinations={["In", "Out", "Ignore"]}
            destinationLabels={[
              t("folderMapper.label.in"),
              t("folderMapper.label.out"),
              t("folderMapper.label.ignore"),
            ]}
            defaultSelection="Ignore"
            ref={(comp) => (this.folderMapper = comp)}
            isLoading={areFoldersLoading}
            error={this.state.folderMapperError}
            errorGettingFolders={this.props.errorGettingFolders}
          />
        </div>
        <div className={s.footer}>
          <Button type="button" color="text" onClick={this.resetAndClose}>
            button.cancel
          </Button>
          <Button onClick={this.startImport} loading={this.state.isSubmitting}>
            button.import
          </Button>
        </div>
      </Modal>
    );
  }
}

export default VaultImportModal;
